import EarthFaultProvider from '../providers/EarthFaultProvider'

var EarthFaultService = function () {
  return {
    async GetEarthFaultAsync (uniqueid, componentid, field, range) {
      return EarthFaultProvider.GetEarthFaultAsync(uniqueid, componentid, field, range)
    }
  }
}
export default new EarthFaultService()



// WEBPACK FOOTER //
// ./src/services/EarthFaultService.js